import ActiveCallControls from './active_call_controls';
import CancelWarmTransfer from 'actions/phone_call/cancel_warm_transfer';
import connect from 'components/lib/connect';
import EndPhoneCall from 'actions/phone_call/end_phone_call';
import HoldPhoneCall from 'actions/phone_call/hold_phone_call';
import MutePhoneCall from 'actions/phone_call/mute_phone_call';
import PhoneCall from 'models/phone_call';
import RemoveParticipantFromPhoneCall from 'actions/phone_call/remove_participant_from_phone_call';
import UpdatePresence from 'actions/agent_activity/update_presence';

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  let activeCallProvider = getProvider('activeCall');
  let activeCall = activeCallProvider.get();
  let currentAgent = getProvider('currentAgent').get();
  let isResponsePending = activeCallProvider.isPending();
  let currentAgentParticipantStatus = activeCall.conversationItem.content.findParticipantById(currentAgent.id).status;
  let customerParticipantStatus = activeCall.conversationItem.content.getCustomerParticipantStatus();
  if (isResponsePending) {
    let pendingPhoneCall = activeCallProvider.getPending().conversationItem.content;
    currentAgentParticipantStatus = pendingPhoneCall.findParticipantById(currentAgent.id).status;
    customerParticipantStatus = pendingPhoneCall.getCustomerParticipantStatus();
  }
  return {
    activeCall,
    currentAgent,
    currentAgentParticipantStatus,
    customerParticipantStatus,
    isRecording:
      activeCall.conversationItem.content.getLatestRecordingEventStatus() !== PhoneCall.RecordingStatus.NOT_RECORDING,
    isResponsePending,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onCancelWarmTransfer: transferee => executeAction(CancelWarmTransfer, transferee),
    onEndPhoneCall: () => executeAction(EndPhoneCall),
    onHoldPhoneCall: ({ participantId, state }) => executeAction(HoldPhoneCall, { participantId, state }),
    onLeaveConference: participantId => executeAction(RemoveParticipantFromPhoneCall, { participantId }),
    onMutePhoneCall: state => executeAction(MutePhoneCall, state),
    onInterval: () => executeAction(UpdatePresence),
  };
}

export default connect(mapStateToProps, mapExecuteToProps)(ActiveCallControls);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/active_call_controls_container.js